































import {
  onAuthUIStateChange,
  CognitoUserInterface
} from '@aws-amplify/ui-components'
import { defineComponent, ref, provide } from '@vue/composition-api'
import Topbar from '@/contexts/frontend/Topbar.vue'
import ErrorsPanel from '@/contexts/errors/ErrorsPanel.vue'
import AppVersion from '@/contexts/frontend/AppVersion.vue'

import { DashboardApi, DashboardApiKey } from './rest/dashboard-api'
import { ClientAdminApi, ClientAdminApiKey } from './rest/client-admin-api'
import { AnalysisApiKey, AnalysisApi } from './rest/analysis-api'
import { MomentsApiKey, MomentsApi } from './rest/moments-api'
import { ConversationsApiKey, ConversationsApi } from './rest/conversations-api'
import { IngestionApi, IngestionApiKey } from './rest/ingestion-api'
import { CommentaryApiKey, CommentaryApi } from './rest/commentary-api'
import { LanguageApiKey, LanguageApi } from './rest/language-api'
import {
  TranscriptionV2Api,
  TranscriptionV2ApiKey
} from './contexts/transcription/src/transcription.api'
import {
  TranscriptionManagerApi,
  TranscriptionManagerApiKey
} from './rest/transcription-manager-api'
import { MediaCdnKey } from './lib/media-cdn'
import { InboxMediaUrlKey } from './lib/inbox-media'
import { provideMomentsState } from '@/contexts/moments/moments'
import { provideVideoState } from '@/contexts/frontend/video'
import { provideErrorsState } from '@/contexts/errors/errors'
import { provideCurrentConversation } from '@/contexts/conversations/current-conversation'
import {
  provideClientIdState,
  useClientIdState
} from '@/contexts/client-admin/clients.state'
import { cfg } from './lib/config'
import { Auth } from 'aws-amplify'

export default defineComponent({
  components: {
    Topbar,
    ErrorsPanel,
    AppVersion
  },
  beforeDestroy() {
    return onAuthUIStateChange
  },
  setup() {
    //eslint-disable-next-line
    console.log(`Config points api request to: ${cfg.basePath}`)

    // This all really belongs in initialization code, near `main.ts`...
    provide(DashboardApiKey, cfg.apis.dashboard as DashboardApi)
    provide(ClientAdminApiKey, cfg.apis.clientAdmin as ClientAdminApi)
    provide(LanguageApiKey, cfg.apis.languages as LanguageApi)
    provide(AnalysisApiKey, cfg.apis.analysis as AnalysisApi)
    provide(MomentsApiKey, cfg.apis.moments as MomentsApi)
    provide(ConversationsApiKey, cfg.apis.conversations as ConversationsApi)
    provide(CommentaryApiKey, cfg.apis.commentary as CommentaryApi)
    provide(MediaCdnKey, cfg.mediaCdn)
    provide(InboxMediaUrlKey, cfg.inboxMediaUrl)
    provide(IngestionApiKey, cfg.apis.ingestion as IngestionApi)
    provide(
      TranscriptionV2ApiKey,
      cfg.apis.transcriptionV2 as TranscriptionV2Api
    )
    provide(
      TranscriptionManagerApiKey,
      cfg.apis.transcriptionManager as TranscriptionManagerApi
    )
    provideErrorsState()
    provideVideoState()
    provideMomentsState()
    provideClientIdState()
    provideCurrentConversation()

    const auth = ref('')
    const user = ref<CognitoUserInterface>(null)
    const clientIdState = useClientIdState()

    onAuthUIStateChange(async (authState, authData) => {
      auth.value = authState
      if (auth.value === 'signedin') {
        // ensure user is KaiAdmin or KaiEditor
        const groups = getUserGroups()
        if (
          (await groups).includes('KaiAdmins') ||
          (await groups).includes('KaiEditors')
        ) {
          user.value = authData as CognitoUserInterface
          clientIdState.clientId = user.value.attributes['custom:client']
        } else {
          window.alert(
            'Insufficient permissions to sign in.\n\nPlease contact administrator for assistance.'
          )
          auth.value = null
          Auth.signOut()
        }
      } else {
        user.value = null
        clientIdState.clientId = null
      }
    })

    async function getUserGroups(): Promise<string[]> {
      try {
        const user = await Auth.currentAuthenticatedUser()
        return user.signInUserSession.accessToken.payload['cognito:groups']
      } catch (error) {
        window.alert(
          'Error fetching user permissions. Please contact system administrator.'
        )
        console.log(`Error:\n${error}`)
      }
    }

    const singleTab = ref(true)

    const channel = new BroadcastChannel('tab')
    channel.postMessage('new-tab')
    let originalTab = true

    channel.addEventListener('message', msg => {
      if (msg.data === 'new-tab' && originalTab) {
        channel.postMessage('already-open')
      }
      if (msg.data === 'already-open') {
        originalTab = false
        singleTab.value = false
        window.alert(
          'You cannot open another TAM while one is already in use. Please close this tab.'
        )
      }
    })

    return {
      singleTab,
      auth,
      user,
      env: cfg.env
    }
  }
})
